import { IHttpInterceptor, ILogService } from "angular";
import { $InjectorLike } from "angular-ui-router";
import { HttpInterceptorFactory } from "./http-interceptor.factory";

/**
 * An Http interceptor that logs a warning to the console if the HTTP response contains
 * a warning.
 * @implements {IHttpInterceptor}
 */
export class ApexWarningInterceptor implements IHttpInterceptor {
    // response?<T>(response: IHttpResponse<T>): IPromise<IHttpResponse<T>> | IHttpResponse<T>;
    /**
     * Create a new ApexWarningInterceptor.
     * @param {any} $injector The AngularJS injector service used to lazy-inject dependencies that use $http.
     */
    constructor(private $injector: $InjectorLike, private $log: ILogService) {
        'ngInject'

    }

    /**
     * Log a warning if the response contains a Warning header
     * @param {IHttpResponse} response The response in the pipeline
     */
    response(response) {
        const apexApiUrl = this.$injector.get("apexApiUrl");
        const debug = this.$injector.get("apexDebugInfoEnabled");
        if (!debug || !response.config.url.includes(apexApiUrl)) {
            return response;
        }

        const warning = response.headers("warning");
        if (warning) {
            this.$log.warn(`Apex API warning: ${warning}`, response.config);
        }
        return response;
    }
}

export const apexWarningInterceptorFactory = HttpInterceptorFactory(ApexWarningInterceptor);
